import { mapState, mapActions } from 'vuex'
import createApp from 'createApp'
const categoryJumbotron = () => import('Components/CategoryQuotation/categoryJumbotron.vue')
const quotationContainer = () => import('Components/CategoryQuotation/quotationContainer.vue')
const quotationSuccess = () => import('Components/CategoryQuotation/quotationSuccess.vue')
const quotationShortcut = () => import('Components/CategoryQuotation/quotationShortcut.vue')
const categoryReview = () => import('Components/CategoryQuotation/categoryReview.vue')
const simplifiedHeader = () => import('Components/Header/simplifiedHeader.vue')
const categoryAbout = () => import('Components/CategoryQuotation/categoryAbout.vue')
import quotationStep from 'Enums/quotationStep'
import { parse as parseUrl } from 'url'
import { parse as parseQuery, stringify as stringifyQuery } from 'qs'
import startCase from 'lodash/startCase'

createApp({
  components: {
    categoryJumbotron,
    quotationContainer,
    quotationSuccess,
    quotationShortcut,
    categoryReview,
    categoryAbout,
    simplifiedHeader
  },

  mounted() {
    this.updateVirtualRoute(this.stepIdentifier)
    this.updateRouteQuery(this.stepIdentifier)
    this.getRegionSlugFromSessionStorage()
  },

  computed: {
    ...mapState({
      status: state => state.categoryQuotation.status,
      currentStep: state => state.categoryQuotation.currentStep,
    }),

    isSent() {
      return this.status.isSent
    },

    stepIdentifier() {
      return this.currentStep.id
    },

    quotationComponent() {
      return this.isSent
        ? 'quotation-success'
        : 'quotation-container'
    },

    asideComponent() {
      return this.isSent
        ? 'quotation-shortcut'
        : 'category-review'
    },
  },

  methods: {
    ...mapActions({
      getRegionSlugFromSessionStorage: 'categoryQuotation/getRegionSlugFromSessionStorage',
    }),

    cleanPath(urlList, pathList, newPath) {
      const lastRoute = pathList[pathList.length - 1]

      const cleanPath = route =>
        newPath = (lastRoute === route)
          ? newPath = pathList.slice(-1).join('/')
          : newPath

      urlList.forEach(cleanPath)

      return newPath
    },

    updateRouteQuery(id) {
      const { href, search, query } = parseUrl(location.href)

      const currentStep = quotationStep.getDescriptionByValue(id)

      const currentQuery = parseQuery(query)
      const newQuery = { ...currentQuery, currentStep }

      const newUrl = href.replace(search, '') + `?${stringifyQuery(newQuery)}`

      history.replaceState(null, currentStep, newUrl)
    },

    updateVirtualRoute(id) {
      const { pathname, search } = parseUrl(location.href)

      const urlList = quotationStep.toList().map(item => item.description)
      const path = pathname.replace(search, '')
      const pathList = path.split('/')

      const cleanPath = this.cleanPath(urlList, pathList, path)
      const stepName = quotationStep.getDescriptionByValue(id)
    },
  },

  watch: {
    stepIdentifier: function (current, previous) {
      if (current !== previous) {
        this.updateVirtualRoute(current)
        this.updateRouteQuery(current)
      }
    },

    isSent: function (current, previous) {
      if (current === true) {
        this.updateVirtualRoute(quotationStep.sent)
        this.updateRouteQuery(quotationStep.sent)
      }
    }
  }
})